import { CssBaseline, ThemeProvider } from "@mui/material";
import Layout from "./layout/layout";
import React from "react";
import { darkTheme, lightTheme } from "./config/theme";
import { useSelector } from "react-redux";
import { getMode } from "./redux/layoutSlice";
import { createGlobalStyle } from "styled-components";

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }

  interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
  }
}

function App() {
  // const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  // const [showInstall, setShowInstall] = useState<boolean>(false);
  const mode = useSelector(getMode);

  // useEffect(() => {
  //   const handleBeforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
  //     console.log("here");
  //     e.preventDefault(); // Stop the automatic install prompt
  //     setDeferredPrompt(e); // Save the event for later use
  //     setShowInstall(true); // Show your install button
  //   };

  //   window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

  //   return () => {
  //     window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  //   };
  // }, []);

  // const handleInstallClick = async () => {
  //   // if (!deferredPrompt) return;
  //   deferredPrompt?.prompt();
  //   const choice = await deferredPrompt?.userChoice;
  //   if (choice?.outcome === "accepted") {
  //     console.log("User accepted the install prompt");
  //   }
  //   setDeferredPrompt(null);
  //   setShowInstall(false);
  // };

  const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${mode === "dark" ? "#000" : "#fff"};
  }
`;

  return (
    <ThemeProvider theme={mode === "dark" ? darkTheme : lightTheme}>
      <CssBaseline enableColorScheme />
      {/* {showInstall && <button onClick={handleInstallClick}>Install App</button>} */}
      <GlobalStyle />
      <Layout />
    </ThemeProvider>
  );
}

export default App;
